import { restAxios } from './httpClient';
import { stripBlankParams } from '../helpers/queryParams';

const COMPONENTS_PATH = '/hardware/components';
const COMPONENT_TYPES_PATH = '/hardware/component-types';

/*
 * One page of fleet components, cancelled by whatever signal the caller passes.
 *
 * This exists next to `getFleetComponents` rather than inside it because the advisory form walks
 * several pages in a row and has to own their cancellation: with a shared module-level controller
 * it could not tell its own next page aborting the previous one from another feature aborting the
 * whole walk. Both functions build the request the same way, so there is still one place a query
 * string is assembled.
 */
export const getFleetComponentsPage = (queryParams, { signal } = {}) => {
	const searchParams = new URLSearchParams(stripBlankParams(queryParams)).toString();

	return restAxios.get(`${COMPONENTS_PATH}?${searchParams}`, { signal });
};

/*
 * Typing in the search box fires a request per debounced keystroke, and the responses can come
 * back out of order. Aborting the in-flight request keeps the table showing the latest query
 * rather than whichever response happened to land last.
 */
let getFleetComponentsController;

export const getFleetComponents = (queryParams) => {
	getFleetComponentsController?.abort();

	getFleetComponentsController = new AbortController();

	return getFleetComponentsPage(queryParams, { signal: getFleetComponentsController.signal });
};

/*
 * Unpaginated: the response is bounded by the size of the component type catalog, not by the
 * fleet, so there is nothing to page through.
 */
export const getComponentTypes = () => {
	return restAxios.get(COMPONENT_TYPES_PATH);
};

/*
 * Records the version HITS endorses for one component type (spec D18, §9).
 *
 * A PATCH rather than a POST to an action path: unlike revoking an advisory or an override, this
 * has no lifecycle - it overwrites a scalar on the component type, and re-approving the same type
 * is an edit rather than a second event.
 *
 * The id is interpolated bare to match the sibling services, and is safe to: these ids are the
 * `String(50)` uuid4s the API generates, and the only ids reaching here come from a row the
 * analytics endpoint returned rather than from anything typed.
 */
export const approveComponentTypeFirmwareVersion = (id, payload) => {
	return restAxios.patch(`${COMPONENT_TYPES_PATH}/${id}`, payload);
};
